/* Global imports. */
import React from "react";
import { Link } from "gatsby"
import { nanoid } from 'nanoid';

import Buy from "@components/Buy";
import EditionImage from "@components/EditionImage";
import { getFormat } from "@src/onix"
import { nonPanMacFormat } from "@src/constants";

/* import models */
import PanMacmillanEdition from "@models/panmacmillan/PanMacmillanEdition";
import PanMacmillanContributor from "@models/panmacmillan/PanMacmillanContributor";

interface Props {
  title?: string;
  limit?: number;
  editions: Array<PanMacmillanEdition>;
  preferredDisplayArray?: Array<any>;
  buttonLink?: string;
  buttonText?: string;
  componentID?: string
  referringSlug?: string
}

const EditionCollection = ({ title, editions, limit, preferredDisplayArray, buttonLink, buttonText, componentID, referringSlug }: Props) => {
  const editionsToDisplay = editions && limit ? editions.slice(0, limit) : editions
  const componentType = "isbn-list";

  function PreferredDisplayContains(codeName:string) {
    return (preferredDisplayArray && preferredDisplayArray.length > 0 && preferredDisplayArray.some(e => e.codename === codeName)) || codeName === "title" || codeName === "contributors"
  }

  return ( 
    <div id={componentID} data-component={componentType} className="w-full mt-12 mb-8 text-center">
    {title && <h2>{title}</h2>}
    <ul className="!pl-0 !list-none mx-[-1rem]">
    {editionsToDisplay && editionsToDisplay.map(edition => {
  
      const thisEdition = edition && edition.node ? edition.node : edition;
      const contributors = thisEdition.contributors && thisEdition.contributors.filter((contributor:any) => ["A01", "A02","A12","A13","B01"].includes(contributor.contributorRole))
      const fullTitle = thisEdition.titleFull

      return (
        <li key={nanoid()} className="text-center inline-flex w-[50%] px-[1rem] pt-[3rem] [&:nth-child(-n+2)]:pt-0 justify-center sm:w-[33.3333333%] sm:[&:nth-child(-n+3)]:pt-0 lg:w-[16.6666666%] lg:[&:nth-child(-n+6)]:pt-0">
		<span className="inline-block w-full">
          <Link to={`/${thisEdition.fields && thisEdition.fields.slug}`} className="!no-underline hover:text-[#999999] w-full" data-ref-slug={referringSlug} data-ref-component-type={componentType} data-ref-component-id={componentID} data-isbn={thisEdition.isbn} data-title={fullTitle} data-author={contributors && contributors[0] && contributors[0].contributorDetails && contributors[0].contributorDetails[0] && contributors[0].contributorDetails[0].personName} data-ispanmac="yes" data-format={thisEdition.format !== nonPanMacFormat ? getFormat(thisEdition.format) : `"${thisEdition.format}"`}>
          <figure className="relative flex flex-wrap justify-center">
            <span className="relative inline-block w-full mb-4">
                <EditionImage isbn={thisEdition.isbn} altImagePath={edition.remoteImage && edition.remoteImage.publicURL} title={fullTitle} loading="lazy" width={thisEdition.dimensions && thisEdition.dimensions.width} height={thisEdition.dimensions && thisEdition.dimensions.height}  />
            </span>
            <figcaption className="min-h-[108px] w-full text-center">
              {PreferredDisplayContains("title") && 
                <h3 className="mb-2 text-lg !leading-6 sm:text-xl bold line-clamp-3" dangerouslySetInnerHTML={{ __html: fullTitle }} />
              }
              {PreferredDisplayContains("contributors") && contributors && contributors.length > 0 && contributors.map(contributor => <p key={nanoid()} className="mb-2 font-sans text-xs" dangerouslySetInnerHTML={{ __html: contributor.contributorDetails && contributor.contributorDetails[0] && contributor.contributorDetails[0].personName}} />
              )}
            </figcaption>
          </figure>
          </Link>
          {PreferredDisplayContains("buy_link") && 
            <Buy
              isbn={thisEdition.isbn}
              edition={thisEdition}
              author={thisEdition.contributors && thisEdition.contributors[0] && thisEdition.contributors[0].contributorDetails && thisEdition.contributors[0].contributorDetails[0]}
              title={fullTitle}
              isPreOrder={!thisEdition.isPublished}
              format={thisEdition.format && thisEdition.format}
              imprint={thisEdition.imprintName && thisEdition.imprintName}
              referringComponentID={componentID}
              referringComponent="Edition Collection"
              data-ref-slug={referringSlug}
            />
          }
		  </span>
        </li>
      )
    })}
    </ul>
    {buttonLink && buttonText && 
    <>
    <p className="text-center my-12"><a className="button" href={buttonLink}>{buttonText}</a></p>
    </>
    }
    </div>
   )
};

export default EditionCollection;
